import React from "react";
import "./Home.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Banner from "../Banner/Banner";
import Products from "../Products/Products";
import QnA from "../QnA/QnA";
import Comments from "../Comments/Comments";

const Home = () => {
  return (
    <div className="home-container">
      <Banner></Banner>
      <Products></Products>
      <Link
        className="text-center btn btn-success w-25 mx-auto d-block my-3 fw-bold"
        as={Button}
        to={`/manageInventory`}
      >
        Manage Inventory
      </Link>
      <Comments></Comments>
      <QnA></QnA>
    </div>
  );
};

export default Home;
